const asyncWrapper = promise =>
  promise
  .then(result => {
    return {
      result,
      error: null
    }
  })
  .catch(error => {
    return {
      error,
      result: null
    }
  });

export default asyncWrapper;